import axios from '@/mod/axiosMod';

export default {
  /**
   * 获取poi列表
   * @returns {*}
   */
  getPoiList(pageNum, pageSize = 100) {
    return axios.post('/shepherd/api/cdb/poi/v3', { pageNum, pageSize }, { timeout: 200000 });
  },
  getTerminatedState() {
    return axios.get('/api/cdb/poi/terminated');
  },
  /**
   * 获取poi列表  重构版
   * @returns {*}
   */
  getPois(pageNum, pageSize = 20) {
    return axios.post('/shepherd/api/cdb/poi/v4', { pageNum, pageSize });
  },
  /**
   * 搜索门店
   * @param {*} data
   * @returns
   */
  searchPoiByName(params) {
    return axios.get('/shepherd/api/kdb/poi/fuzzyQuery', { params });
  },
  /**
   * 搜索门店(支持id和名称)
   * @param {*} data
   * @returns
   */
  searchPoi(params) {
    return axios.get('/apigw/api/res/dx/bill/fuzzy-search-poi-list', { params });
  },
  haveProxyPoi() {
    return axios.get('/apigw/api/kdb/partner/existAgent');
  },
};
// /api/cdb/poi/v4
